import { render, staticRenderFns } from "./AppDownloadTemplate.vue?vue&type=template&id=4606f918&"
import script from "./AppDownloadTemplate.vue?vue&type=script&lang=js&"
export * from "./AppDownloadTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports